<template>
    <div id="navigation-bar-menu">
        
        <burger-menu class="m-3"></burger-menu>
        
        <header-menu-background></header-menu-background>

        <nav class="d-flex flex-column p-8">
            <a href="/">
                <img id="navigation-bar-logo" class="align-self-start mb-8" src="/images/imagotipo-menu.svg" alt="" height=85 >
            </a>

            <site-search class="shadow mb-8 hidden-xs-up"></site-search>

            <ul class="nav-menu list-unstyled">
                <slot></slot>
            </ul>

            <slot name="footer"></slot>
        </nav>
    </div>
</template>

<script>
    export default {

        mounted: function () {
            bus.$on('burger-menu-open', () => {
                $(this.$el).width('30rem');
            });

            bus.$on('burger-menu-close', () => {
                $(this.$el).width(0);
            });
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #navigation-bar-menu{
        height: 100vh;
        width: 0;
        transition: width 0s 2s;

        #burger-menu.open {
            ~ nav{
                opacity: 1;
                transform: translate3d(0, 0, 0);
                transition: all .5s ease-out .2s;
            }
        }
        
        > nav{
            height: calc(100% - 4rem);
            width: 20rem;
            z-index: $zindex-sticky;
            transform: translate3d(-100%, 0, 0);
            opacity: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/NavigationBarMenu.vue